import React from 'react';

import FleetOpsSuspense from 'FleetOpsSuspense';

import TopBar from './TopBar';
import SideBar from './SideBar';
import Content from './Content';
import AppLayout from '../Common/AppLayout';

const Standard = () => {
  return (
    <AppLayout
      TopBar={<TopBar />}
      SideBar={<SideBar />}
      Content={
        // Screens load as their routes open: keep the bars while one does
        <FleetOpsSuspense>
          <Content />
        </FleetOpsSuspense>
      }
    />
  );
};

export default Standard;
